import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import {
  Alert,
  Button,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container } from '@mui/system';

import DynamicBreadcrumbs from '@/components/nav/Breadcrumb';
import ResourcesRightSidebar from '@/components/nav/ResourcesRightSidebar';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const Form1125E = () => {
  return (
    <AppLayout
      meta={
        <Meta
          title="IRS Form 1125-E: Compensation of Officers Instructions"
          description="IRS Form 1125-E reports corporate officers' compensation. Learn who must file, key instructions, deadlines, and how to attach it with Form 1120-S."
          keywords=""
          canonical="resources/business-tax/form-1125-e/"
          ogType="article"
          jsonLdPricing="179.99"
          jsonLdAggregateRatingValue="4.97"
          jsonLdAggregateRatingCount="1658"
        />
      }
    >
      <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
        <Typography
          variant="h1"
          sx={{
            fontSize: { lg: 40, md: 36, sm: 32, xs: 24 },
            fontWeight: 600,
            mb: 5,
            mt: 5,
            textAlign: 'center',
          }}
        >
          IRS{' '}
          <span className="highlight-container">
            <span className="highlight">Form 1125-E</span>
          </span>{' '}
          : Compensation of Officers
        </Typography>
        {/* <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mt: 1,
            mb: 2,
          }}
        >
          E-File your IRS <span style={{ fontWeight: 600 }}> Form 1120-S</span>{' '}
          for the 2024 tax year by{' '}
          <span style={{ fontWeight: 600 }}>March 17, 2025,</span> to meet
          federal S
          <Hidden smDown>
            {' '}
            <br />
          </Hidden>{' '}
          corporation filing deadlines and avoid potential penalties.
        </Typography>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Button
            variant="contained"
            className="btn-primary medium"
            sx={{
              fontSize: {
                xs: '16px !important',
                sm: '18px !important',
                lg: '24px !important',
              },
              transition: 'all 0.3s ease 0s',
              '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
            }}
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120sduedates`}
          >
            E-file Now!
          </Button> */}
        {/* </Box> */}
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          py: 5,
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        mt={0}
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          <DynamicBreadcrumbs />
          <Grid
            container
            spacing={0}
            rowSpacing={0}
            m={0}
            sx={{ flexDirection: 'row-reverse' }}
          >
            <Grid
              size={{ xs: 12, md: 3.5, sm: 4.5 }}
              sx={{ display: { xs: 'none', sm: 'block' } }}
            >
              <ResourcesRightSidebar />
            </Grid>
            <Grid size={{ xs: 12, md: 8.5, sm: 7.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  border: '1px solid #ccc',
                  p: 3,
                  px: 3,
                  textAlign: 'left',
                  mb: 0,
                  minHeight: '100%',
                }}
              >
                <Box
                  component="article"
                  itemScope
                  itemType="https://schema.org/Article"
                  sx={{
                    p: 3,
                    px: 3,
                    backgroundColor: '#f0f5f8',
                    borderLeft: '5px solid #01456c',
                    mb: 4,
                    borderRadius: 3,
                    position: 'relative',
                  }}
                >
                  <link
                    itemProp="mainEntityOfPage"
                    href="https://www.taxzerone.com/resources/business-tax/form-1125-e/"
                  />
                  {/* Article requires an image */}
                  <div
                    itemProp="image"
                    itemScope
                    itemType="https://schema.org/ImageObject"
                    style={{ display: 'none' }}
                  >
                    <link
                      itemProp="url"
                      href="https://www.taxzerone.com/assets/images/logo.webp"
                    />
                    <data itemProp="width" value="380" />
                    <data itemProp="height" value="124" />
                  </div>
                  <Box
                    sx={{
                      display: 'grid',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      textAlign: 'left',
                      mb: 2,
                    }}
                  >
                    <Typography variant="body2">
                      Last updated:{' '}
                      <time
                        itemProp="datePublished"
                        dateTime="2026-08-25T09:00:00-05:00"
                      >
                        Aug 25, 2026
                      </time>
                      <time
                        itemProp="dateModified"
                        dateTime="2026-08-25T09:00:00-05:00"
                        style={{ display: 'none' }}
                      >
                        Aug 25, 2026
                      </time>
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600 }}
                      itemProp="author"
                      itemScope
                      itemType="https://schema.org/Person"
                    >
                      -by{' '}
                      <span itemProp="name">
                        <a
                          itemProp="url"
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}`}
                          style={{
                            color: 'inherit',
                            textDecoration: 'none',
                          }}
                        >
                          Nikhil Chowdary
                        </a>
                      </span>{' '}
                      | TaxZerone
                    </Typography>
                  </Box>
                  <Typography
                    component="h2"
                    itemProp="headline"
                    variant="h4"
                    sx={{
                      fontWeight: 600,
                      mb: 0.8,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      color: '#01456c',
                      fontStyle: 'italic',
                    }}
                  >
                    IRS Form 1125-E at a glance
                  </Typography>

                  <Box
                    component="ul"
                    itemScope
                    itemType="https://schema.org/ItemList"
                    sx={{
                      mb: 0,
                      pl: 0,
                      listStyle: 'none',
                      '& li': { mb: 1.6, position: 'relative', pl: 3 },
                      '& li::before': {
                        content: '"★"',
                        position: 'absolute',
                        left: 0,
                        top: '-2px',
                        color: '#01456c',
                        fontSize: '18px',
                      },
                    }}
                  >
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="1" />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Understand the purpose of IRS Form 1125-E
                          (Compensation of Officers)
                        </strong>{' '}
                        and how corporations use it to report officer salaries,
                        ownership details, and compensation deductions on Form
                        1120 and Form 1120-S.
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="2" />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Learn who must file Form 1125-E
                        </strong>{' '}
                        and how IRS requirements apply to C corporations and S
                        corporations that report officer compensation and meet
                        the applicable gross receipts threshold.
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="3" />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Explore how to complete Form 1125-E line by line,
                        </strong>{' '}
                        including officer information, ownership percentages,
                        compensation amounts, deductions reported elsewhere, and
                        the final compensation deduction.
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="4" />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Understand IRS reasonable compensation rules
                        </strong>{' '}
                        and how factors such as officer responsibilities,
                        business size, industry standards, and services provided
                        affect compensation reporting.
                      </span>
                    </li>
                  </Box>
                </Box>
                <Stack
                  direction={{ xs: 'column-reverse', md: 'row' }}
                  spacing={{ xs: 1, sm: 2, md: 3 }}
                  sx={{ mb: 0 }}
                >
                  <Box>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      If you’re filing a corporate income tax return, such as
                      <Link
                        href="/business-returns/efile-irs-form-1120-s/"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form 1120-S
                      </Link>
                      ,{' '}
                      <span style={{ fontWeight: 600 }}>
                        and paid salaries to your corporate officers, you may
                        need to include IRS{' '}
                        <Link
                          href="https://www.irs.gov/pub/irs-pdf/f1125e.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Form 1125-E
                        </Link>
                        , Compensation of Officers
                      </span>
                      .
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      This form helps the IRS verify that the salaries deducted
                      on your return are{' '}
                      <span style={{ fontWeight: 600 }}>
                        reasonable, accurately reported
                      </span>
                      , and reflect actual business services rendered.
                    </Typography>
                  </Box>
                  <Box
                    sx={{ mb: 1, textAlign: { xs: 'center', md: 'left' } }}
                  />
                </Stack>
                <Box
                  sx={{
                    pt: 0,
                  }}
                >
                  <Typography variant="body1" sx={{ mb: 0.5 }}>
                    <b>Table of Contents</b>
                  </Typography>
                  <List
                    sx={{ mb: 5, border: '1px solid #ccc', borderRadius: 2 }}
                  >
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whatis" sx={{ color: '#0202ff' }}>
                          What is IRS Form 1125-E?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#purpose" sx={{ color: '#0202ff' }}>
                          Purpose of IRS Form 1125-E
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whomust" sx={{ color: '#0202ff' }}>
                          Who Must File Form 1125-E?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#deadline" sx={{ color: '#0202ff' }}>
                          Filing Deadlines for Form 1125-E
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#detailed" sx={{ color: '#0202ff' }}>
                          Detailed Line-by-Line Instructions for Form 1125-E
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#counts" sx={{ color: '#0202ff' }}>
                          What Counts as “Officer Compensation”?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#reasonable" sx={{ color: '#0202ff' }}>
                          Reasonable Compensation — A Key IRS Focus
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#required" sx={{ color: '#0202ff' }}>
                          Required Documentation
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#common" sx={{ color: '#0202ff' }}>
                          Common Errors and Penalties
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#key" sx={{ color: '#0202ff' }}>
                          Key Tips for Compliance
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#faqs" sx={{ color: '#0202ff' }}>
                          Frequently Asked Questions (FAQs)
                        </Link>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 2,
                    scrollMarginTop: 83,
                  }}
                  id="whatis"
                >
                  What is IRS Form 1125-E?
                </Typography>

                <Typography variant="body1" sx={{ mb: 1 }}>
                  <span style={{ fontWeight: 600 }}>
                    IRS Form 1125-E, Compensation of Officers
                  </span>
                  , is an informational attachment required by the IRS for
                  corporations that report officer salaries as part of their
                  deductions. It lists each corporate officer, their ownership
                  percentage, time devoted to business, and total compensation.
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  The IRS uses this information to ensure that salaries are{' '}
                  <span style={{ fontWeight: 600 }}>
                    not artificially inflated
                  </span>{' '}
                  to reduce taxable corporate income.
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Businesses must complete Form 1125-E when their{' '}
                  <span style={{ fontWeight: 600 }}>
                    total receipts are $500,000 or more
                  </span>{' '}
                  and officer compensation is deducted on their return.
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  The form applies to:
                </Typography>
                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 2 }}>
                  <li>
                    <span style={{ fontWeight: 600 }}> S Corporations</span>{' '}
                    filing{' '}
                    <Link
                      href="/business-returns/efile-irs-form-1120-s/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Form 1120-S
                    </Link>{' '}
                    and
                  </li>
                  <li>
                    You <span style={{ fontWeight: 600 }}>C Corporations</span>{' '}
                    filing{' '}
                    <Link
                      href="https://www.irs.gov/pub/irs-pdf/f1120.pdf"
                      target="_blank"
                      sx={{ color: '#0202ff' }}
                    >
                      Form 1120
                    </Link>
                    .
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  It is <span style={{ fontWeight: 600 }}>not</span> required
                  for partnerships, sole proprietorships, or corporations under
                  the $500,000 receipts threshold.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="purpose"
                >
                  Purpose of IRS Form 1125-E
                </Typography>

                <Typography variant="body1" sx={{ mb: 1 }}>
                  The purpose of Form 1125-E is twofold:
                </Typography>

                <Box component="ol" sx={{ '& li': { mb: 1.5 }, mb: 3 }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>Tax Transparency: </span>{' '}
                    It discloses how much compensation was paid to each officer
                    and how much ownership each officer holds.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>IRS Oversight:</span> It
                    enables the IRS to assess whether salaries are “reasonable”
                    as per{' '}
                    <span style={{ fontWeight: 600 }}>
                      Internal Revenue Code Section 162(a)(1)
                    </span>
                    , which permits deductions only for “ordinary and necessary”
                    business expenses, including reasonable salaries for
                    services actually performed.
                  </li>
                </Box>

                <Typography variant="body1" sx={{ mb: 4 }}>
                  This helps prevent abuse—such as distributing profits
                  disguised as salaries to avoid double taxation in C
                  corporations or underpaying S corporation officers to reduce
                  employment taxes.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="whomust"
                >
                  Who Must File Form 1125-E?
                </Typography>

                <Typography variant="body1" sx={{ mb: 1 }}>
                  Form 1125-E is required for{' '}
                  <span style={{ fontWeight: 600 }}>
                    corporations that meet all three criteria below:
                  </span>
                </Typography>
                <Box component="ol" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>
                    The corporation files{' '}
                    <span style={{ fontWeight: 600 }}>Form 1120-S</span> or{' '}
                    <span style={{ fontWeight: 600 }}>Form 1120.</span>{' '}
                  </li>
                  <li>
                    {' '}
                    The corporation’s{' '}
                    <span style={{ fontWeight: 600 }}>
                      total receipts are $500,000 or more
                    </span>{' '}
                    for the tax year.{' '}
                  </li>
                  <li>
                    {' '}
                    The corporation{' '}
                    <span style={{ fontWeight: 600 }}>
                      paid compensation
                    </span>{' '}
                    to officers during that tax year.{' '}
                  </li>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Corporations Required to File
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>S Corporations</span>{' '}
                    reporting officer salaries on{' '}
                    <span style={{ fontWeight: 600 }}>Form 1120-S</span>
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>C Corporations</span>{' '}
                    reporting deductions on{' '}
                    <span style={{ fontWeight: 600 }}>Form 1120</span>
                  </li>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Corporations Not Required to File
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>Partnerships</span> (
                    <Link
                      href="https://www.irs.gov/pub/irs-pdf/f1065.pdf"
                      target="_blank"
                      sx={{ color: '#0202ff' }}
                    >
                      Form 1065
                    </Link>
                    )
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      Sole proprietorships (Schedule C){' '}
                    </span>{' '}
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      Corporations with total receipts under $500,000
                    </span>{' '}
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>LLCs</span> that are not
                    taxed as corporations
                  </li>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="deadline"
                >
                  Filing Deadlines for Form 1125-E
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Form 1125-E must be filed along with your main corporate
                  income tax return.
                </Typography>
                <Box component="div" sx={{ mb: 2 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Entity Type
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Main Return
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Due Date
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>C Corporations </TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Form 1120{' '}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>
                            April 15, 2026
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>S Corporations </TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Form 1120-S{' '}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>
                            March 16, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  If you need more time, you can file for an automatic extension
                  using{' '}
                  <Link
                    href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 7004
                  </Link>{' '}
                  before the original due date.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="detailed"
                >
                  Detailed Line-by-Line Instructions for Form 1125-E
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Each section of the form captures essential details about
                  officer compensation. Let’s break it down line by line:
                </Typography>
                <Typography
                  variant="h3"
                  sx={{ fontWeight: 600, mb: 0.8, fontSize: '18px !important' }}
                >
                  Line 1 – Officer Information
                </Typography>
                <picture>
                  <source srcSet="/assets/images/f1125e-compensation-img.webp" />
                  <source srcSet="/assets/images/f1125e-compensation-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/f1125e-compensation-img.png"
                    loading="lazy"
                    alt="IRS Form 1125-E Compensation of Officers attached to Forms 1120, 1120-C, 1120-F, 1120-REIT, 1120-RIC, and 1120-S."
                    width={760}
                    height={314}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 0,
                    }}
                  />
                </picture>
                <Typography variant="body1">
                  Complete{' '}
                  <strong style={{ fontWeight: 600 }}>
                    {' '}
                    columns (a) through (f)
                  </strong>{' '}
                  for every corporate officer.
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    <strong style={{ fontWeight: 600 }}>Column (a):</strong>{' '}
                    Enter the officer's name.
                  </li>
                  <li>
                    <strong style={{ fontWeight: 600 }}> Column (b):</strong>{' '}
                    Enter the officer's Social Security Number (SSN). You may
                    enter only the last four digits if you choose.
                  </li>
                  <li>
                    <strong style={{ fontWeight: 600 }}>Column (c):</strong>{' '}
                    Enter the percentage of time the officer devoted to the
                    business during the tax year.
                  </li>
                  <li>
                    <strong style={{ fontWeight: 600 }}>
                      {' '}
                      Columns (d) and (e):
                    </strong>{' '}
                    Enter the percentage of common and preferred stock owned by
                    the officer.
                  </li>
                  <li>
                    <strong style={{ fontWeight: 600 }}> Column (f):</strong>{' '}
                    Enter the officer's total deductible compensation, including
                    salaries, commissions, bonuses, and taxable fringe benefits.
                    For S corporations, include fringe benefits provided to
                    officers who own more than 2% of the corporation's stock. Do
                    not include fringe benefits for officers owning 2% or less,
                    as those are deducted elsewhere on the tax return.
                  </li>
                </Box>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{ mt: 0, mb: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
                  id="filing"
                >
                  <b>Note :</b>{' '}
                  <i>
                    If filing a consolidated return, report all officers of the
                    affiliated group. The common parent may file a single Form
                    1125-E for the entire group.{' '}
                  </i>
                </Alert>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Line 2 – Total Compensation of Officers
                </Typography>
                <picture>
                  <source srcSet="/assets/images/f1125e-line2-img.webp" />
                  <source srcSet="/assets/images/f1125e-line2-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/f1125e-line2-img.png"
                    loading="lazy"
                    alt="Form 1125-E Line 2 for reporting the total compensation paid to corporate officers"
                    width={760}
                    height={34}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 1,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Add the compensation amounts from{' '}
                  <strong style={{ fontWeight: 600 }}>column (f)</strong> for
                  all officers and enter the total on line 2.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{ fontWeight: 600, mb: 0.8, fontSize: '18px !important' }}
                >
                  Line 3 – Compensation Deducted Elsewhere
                </Typography>
                <picture>
                  <source srcSet="/assets/images/f1125e-line3-img.webp" />
                  <source srcSet="/assets/images/f1125e-line3-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/f1125e-line3-img.png"
                    loading="lazy"
                    alt="Form 1125-E Line 3 for reporting officer compensation deducted elsewhere on the tax return"
                    width={760}
                    height={34}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 1,
                    }}
                  />
                </picture>
                <Typography variant="body1">
                  Complete columns (a) through (f) for every corporate officer.
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>Compensation included in cost of goods sold (COGS).</li>
                  <li>Elective contributions to a section 401(k) plan. </li>
                  <li>
                    Contributions made under a salary reduction SEP
                    agreement.{' '}
                  </li>
                  <li>Contributions to a SIMPLE IRA plan. </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  If the corporation claims certain wage-related tax credits, it
                  may need to reduce its compensation deduction under{' '}
                  <strong style={{ fontWeight: 600 }}> IRC section 280C</strong>
                  . Also, do not include depreciation or other expenses for
                  taxable fringe benefits that are deducted elsewhere on the
                  return.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{ fontWeight: 600, mb: 0.8, fontSize: '18px !important' }}
                >
                  Line 4 – Compensation Deduction to Report
                </Typography>
                <picture>
                  <source srcSet="/assets/images/f1125e-line4-img.webp" />
                  <source srcSet="/assets/images/f1125e-line4-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/f1125e-line4-img.png"
                    loading="lazy"
                    alt="Form 1125-E Line 4 for reporting the compensation deduction to claim on the tax return."
                    width={760}
                    height={50}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 1,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Subtract <strong style={{ fontWeight: 600 }}> line 3</strong>{' '}
                  from <strong style={{ fontWeight: 600 }}> line 2.</strong>{' '}
                  Enter the result on{' '}
                  <strong style={{ fontWeight: 600 }}> line 4</strong> and
                  report the same amount on{' '}
                  <strong style={{ fontWeight: 600 }}>
                    {' '}
                    Form 1120, page 1, line 12,
                  </strong>{' '}
                  or the corresponding compensation line on the applicable
                  business tax return.
                </Typography>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Supporting Schedule Attachments
                </Typography>

                <Typography variant="body1" sx={{ mb: 3 }}>
                  If the corporation has more than four officers, attach an
                  additional sheet with the same information for each additional
                  officer.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Example of Officer Compensation Reporting
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Example:
                </Typography>
                <Typography variant="body1" sx={{ mb: 1.5 }}>
                  XYZ Tech Inc., an S Corporation, earned $1.2 million in gross
                  receipts for the year. The company paid:
                </Typography>
                <Box component="div" sx={{ mb: 2 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Officer
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Role
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Ownership
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Time Devoted
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Compensation
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>John Miller</TableCell>

                          <TableCell>President</TableCell>
                          <TableCell>60%</TableCell>
                          <TableCell>100%</TableCell>
                          <TableCell>$120,000</TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Lisa Brown </TableCell>
                          <TableCell>CFO </TableCell>
                          <TableCell>40%</TableCell>
                          <TableCell>100%</TableCell>
                          <TableCell>$95,000 </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  The total officer compensation of{' '}
                  <span style={{ fontWeight: 600 }}> $215,000</span> is reported
                  on <span style={{ fontWeight: 600 }}>Form 1125-E</span> and
                  carried over to{' '}
                  <span style={{ fontWeight: 600 }}>
                    Form 1120-S, Line 12 (Compensation of Officers)
                  </span>
                  .
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="counts"
                >
                  What Counts as “Officer Compensation”?
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Officer compensation includes all taxable wages and fringe
                  benefits provided in exchange for services, such as:
                </Typography>

                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 2 }}>
                  <li>Salaries and bonuses</li>
                  <li>Commission-based pay</li>
                  <li>Company-paid health insurance premiums</li>
                  <li>Employer contributions to retirement plans </li>
                  <li>
                    Certain taxable fringe benefits (e.g., personal vehicle
                    use){' '}
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  It <span style={{ fontWeight: 600 }}> does not</span> include:
                </Typography>
                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 3 }}>
                  <li>Dividend distributions </li>
                  <li>Return of capital </li>
                  <li>Reimbursement of expenses (if properly documented) </li>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="reasonable"
                >
                  Reasonable Compensation — A Key IRS Focus
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    mb: 1,
                  }}
                >
                  The IRS carefully examines whether officer compensation is
                  <span style={{ fontWeight: 600 }}> “reasonable”</span> based
                  on several factors, such as:
                </Typography>
                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 2 }}>
                  <li>
                    The officer’s{' '}
                    <span style={{ fontWeight: 600 }}>
                      role and responsibilities
                    </span>{' '}
                  </li>
                  <li>
                    The{' '}
                    <span style={{ fontWeight: 600 }}>size and complexity</span>{' '}
                    of the business
                  </li>
                  <li>
                    {' '}
                    <span style={{ fontWeight: 600 }}>
                      Comparable salaries
                    </span>{' '}
                    in the same industry
                  </li>
                  <li>
                    The company’s{' '}
                    <span style={{ fontWeight: 600 }}>
                      gross receipts and profitability
                    </span>{' '}
                  </li>
                  <li>
                    The officer’s{' '}
                    <span style={{ fontWeight: 600 }}>
                      time commitment and skills
                    </span>{' '}
                  </li>
                </Box>
                <Typography
                  variant="body1"
                  sx={{
                    mb: 1,
                  }}
                >
                  If compensation is deemed excessive or unreasonable, the IRS
                  may:
                </Typography>
                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 2 }}>
                  <li>
                    Reclassify part of it as nondeductible dividends (for C
                    corps), or{' '}
                  </li>
                  <li>
                    Treat underpaid salaries in S corps as taxable wages subject
                    to employment tax.{' '}
                  </li>
                </Box>
                <Typography
                  variant="body1"
                  sx={{
                    mb: 0.6,
                    fontWeight: 600,
                  }}
                >
                  Example:
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    mb: 3,
                  }}
                >
                  An S Corporation where the sole shareholder pays themselves
                  only $10,000 in salary but withdraws $100,000 in distributions
                  is likely to face IRS scrutiny. The IRS may reclassify part of
                  the distributions as wages, triggering payroll taxes and
                  penalties.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="required"
                >
                  Required Documentation
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  To ensure compliance and support deductions claimed on Form
                  1125-E, corporations should maintain:
                </Typography>

                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 2 }}>
                  <li>
                    Officer employment agreements or board resolutions approving
                    pay
                  </li>
                  <li>
                    Maintain payroll records and W-2 forms (
                    <Link
                      href="/information-returns/efile-irs-form-w2/"
                      sx={{ color: '#0202ff' }}
                    >
                      File Form W-2
                    </Link>{' '}
                    for all officers).
                  </li>
                  <li>
                    Documentation of bonuses, insurance premiums, and benefits
                  </li>
                  <li>Ownership records and stock certificates</li>
                  <li>
                    Minutes of board meetings discussing officer
                    compensation{' '}
                  </li>
                  <li>Benchmark data on comparable salary levels </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Maintaining thorough documentation will help defend your
                  deductions during an IRS review.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="common"
                >
                  Common Errors and Penalties
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Frequent filing mistakes:
                </Typography>
                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 2 }}>
                  <li>Failing to file Form 1125-E when required</li>
                  <li>
                    Mismatch between officer compensation on Form 1125-E and
                    Form 1120-S/1120
                  </li>
                  <li>Missing SSNs or incomplete ownership details</li>
                  <li>
                    Reporting salaries that appear unreasonably high or low{' '}
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Possible consequences:
                </Typography>
                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 2 }}>
                  <li>IRS disallowance of compensation deduction </li>
                  <li>Reclassification of wages or dividends</li>
                  <li>Additional taxes, penalties, or interest charges </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  To avoid issues, always reconcile your payroll data with the
                  total officer compensation reported.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="key"
                >
                  Key Tips for Compliance
                </Typography>
                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 4 }}>
                  <li>
                    Ensure compensation aligns with fair market value and
                    business size.{' '}
                  </li>
                  <li>
                    Keep accurate payroll and shareholder ownership
                    records.{' '}
                  </li>
                  <li>
                    Attach supporting documentation if more than four officers
                    are listed.{' '}
                  </li>
                  <li>
                    Double-check totals to ensure consistency with Form 1120 or
                    1120-S.{' '}
                  </li>
                  <li>
                    <Link
                      href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      File Form 7004
                    </Link>{' '}
                    for an extension if you need more time.{' '}
                  </li>
                  <li>
                    Review updated IRS instructions annually before filing.{' '}
                  </li>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="faqs"
                >
                  Frequently Asked Questions (FAQs)
                </Typography>

                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  1. Do all corporations have to file Form 1125-E?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  No. Only C and S corporations with total receipts of $500,000
                  or more that deduct officer compensation must file this form.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  2. What does the IRS consider “reasonable compensation”?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  It’s the amount an independent employer would pay for similar
                  services under similar circumstances. Factors include business
                  size, complexity, duties, and time spent.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  3. How many officers can be listed on Form 1125-E?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Up to four. If you have more than four officers, attach a
                  supplemental schedule providing identical information.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  4. Can I e-file Form 1125-E separately?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  No. It must be filed along with your{' '}
                  <span style={{ fontWeight: 600 }}> Form 1120</span> or{' '}
                  <span style={{ fontWeight: 600 }}>Form 1120-S</span>. When you
                  e-file your corporate return with{' '}
                  <span style={{ fontWeight: 600 }}>TaxZerone</span>, Form
                  1125-E is automatically included if required.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  5. What happens if I underpay myself as an S Corporation
                  officer?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  The IRS may reclassify part of your distributions as wages,
                  making them subject to Social Security and Medicare taxes.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  6. Are benefits like health insurance included in officer
                  compensation?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Yes, if the corporation pays these benefits on behalf of the
                  officer and includes them as taxable income on the officer’s
                  W-2.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  7. What if no officers received compensation during the year?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  If no salaries or wages were paid to officers, Form 1125-E is
                  not required.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Container maxWidth="lg" sx={{ mb: 5, my: { xs: 6, sm: 6, md: 6 } }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 2, md: 5 }}
        >
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 2,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              E-File Your Form 1120-S with TaxZerone
            </Typography>
            <Typography
              variant="h3"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 3,
              }}
            >
              Simplify your corporate tax filing with TaxZerone, ensuring
              accuracy and full IRS compliance.
            </Typography>

            <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
              <Button
                variant="contained"
                sx={{
                  mt: 1,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-primary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1125e`}
              >
                Start E-Filing Now
              </Button>
            </Box>
          </Box>
        </Stack>
      </Container>
    </AppLayout>
  );
};

export default Form1125E;
